export default function LoyaltyProgramTermsAndConditions() {
	return (
		<div className="terms">
			<h1>
				<b>InstantCosmetics Loyalty Program Terms &amp; Conditions</b>
			</h1>

			<p>
				<b>For Healthcare Professionals</b>
			</p>

			<h3>1. Introduction</h3>
			<p>
				These InstantCosmetics Loyalty Program Terms &amp; Conditions ("T&amp;Cs") govern the InstantCosmetics Loyalty Program operated by InstantCosmetics. By participating in
				the loyalty program, you agree to abide by these T&amp;Cs and any amendments made from time to time. It is your responsibility to read and understand the T&amp;Cs.
			</p>
			<p>
				These T&amp;Cs are effective as at the date specified above. The most recent T&amp;Cs are always available on InstantCosmetic's website at{' '}
				<a href="https://instantcosmetics.com.au/">https://instantcosmetics.com.au/</a>.
			</p>
			<p>
				InstantCosmetics reserves the right to make changes to the loyalty program at any time and may modify, suspend, or terminate any aspect of the program. If a member
				continues to participate in the loyalty program following any changes, the member will be deemed to have accepted the changes.
			</p>

			<h3>2. Eligibility</h3>
			<p>
				Membership of the loyalty program is only open to Healthcare Professionals who purchase products from InstantCosmetics and/or obtain scripts for patients from doctors made
				available by InstantCosmetics. You will be required to provide proof of doctor or nurse registration prior to your participation in the program and may be required to
				provide evidence of your annual spend with InstantCosmetics in order to determine tier status.
			</p>

			<h3>3. Membership Tiers</h3>
			<ul>
				<li>
					<b>Silver Tier (Entry Level):</b> All new accounts start at Silver status unless identified as Gold or Platinum based on proof of spend.
				</li>
				<li>
					<b>Gold Tier:</b> Achieved through higher annual spend, with benefits increasing accordingly.
				</li>
				<li>
					<b>Platinum Tier:</b> Reserved for users with the highest annual spend, granting access to premium rewards and recognition.
				</li>
			</ul>

			<h4>Tier Qualification Criteria</h4>
			<ul>
				<li>
					<b>Silver Tier:</b> No minimum spend required. All eligible Healthcare Practitioners are enrolled at this tier by default.
				</li>
				<li>
					<b>Gold Tier:</b> Achieved by reaching a minimum annual spend of $150,000 exc GST (AUD) on eligible products and/or scripts within the defined annual period.
				</li>
				<li>
					<b>Platinum Tier:</b> Achieved by reaching a minimum annual spend of $250,000 exc GST (AUD) on eligible products and/or scripts within the defined annual period.
				</li>
			</ul>
			<p>InstantCosmetics may request proof of spend to confirm eligibility for Gold or Platinum tiers.</p>

			<h4>Annual Period Definition</h4>
			<p>
				The annual period for calculating tier status runs from Calendar year 1st Jan – 31st December. All eligible spend within this period is counted towards tier qualification
				and retention for the following year.
			</p>

			<h4>Tier Retention &amp; Demotion</h4>
			<ul>
				<li>Tier status is reviewed annually at the end of each period.</li>
				<li>To retain Gold or Platinum status, users must meet the respective minimum spend thresholds during the annual period.</li>
				<li>
					If a user does not meet the minimum spend required for their current tier, they will be moved down to the tier that matches their annual spend level for the new period
					starting 1 January.
				</li>
				<li>InstantCosmetics will notify users of any change to their tier status prior to the commencement of the new annual period.</li>
			</ul>

			<h3>4. Tier Advancement</h3>
			<p>
				Tier status is automatically determined by your annual spend with InstantCosmetics. Proof of spend may be requested to confirm eligibility for Gold or Platinum tiers.
				Progression through the tiers results in increased benefits.
			</p>

			<h3>5. Benefits</h3>
			<p>
				Each tier offers specific rewards, such as progressive discounts and tangible benefits reflecting your engagement and loyalty. The exact nature and value of these benefits
				may be updated at the discretion of InstantCosmetics.
			</p>

			<h3>6. General Conditions</h3>
			<ul>
				<li>InstantCosmetics reserves the right to modify, suspend, or terminate the loyalty program or any tier benefits at any time.</li>
				<li>Membership and tier status are non-transferable and only valid for the registered doctor / nurse user account.</li>
				<li>Any misuse or fraudulent activity may result in termination of membership and forfeiture of benefits.</li>
				<li>To the extent permissible by law InstantCosmetics will not be liable for any errors, omissions, delays or disruptions in the operation of the loyalty program.</li>
				<li>To participate in the loyalty program, you must reside in Australia.</li>
				<li>
					A member may not assign or delegate or otherwise deal with all or any of their rights or obligations under these T&amp;Cs. InstantCosmetics has the right to assign or
					otherwise delegate all or any of its rights or obligations under these T&amp;Cs to any person.
				</li>
				<li>
					InstantCosmetics shall not be liable for a breach of its obligations under these T&amp;Cs where InstantCosmetics is hindered or prevented from carrying out its obligations
					by any cause outside its reasonable control, including pandemic, lightning, fire, flood, extremely severe weather, strike, lock-out, labour dispute, act of God, war, riot,
					civil commotion, malicious damage, failure of any telecommunications or computer system, compliance with any law, accident (or by any damage caused by any of such events).
				</li>
				<li>
					If any provision of these T&amp;Cs is held to be unlawful, invalid or unenforceable, that provision shall be deemed severed and the validity and enforceability of the
					remaining provisions of these T&amp;Cs shall not be affected.
				</li>
				<li>
					These T&amp;Cs shall be governed by and construed in accordance with the laws of Victoria and both parties hereby submit to the non-exclusive jurisdiction of the courts of
					Victoria.
				</li>
			</ul>

			<h3>7. Privacy</h3>
			<p>
				By participating in the InstantCosmetics loyalty program, you agree to the collection, use and disclosure of your personal information in accordance with the Wesfarmers
				Health privacy policy available on{' '}
				<a href="https://instantcosmetics.com.au/">instantcosmetics.com.au</a> and you acknowledge that you have read the Privacy Policy.
			</p>

			<h3>8. Contact &amp; Support</h3>
			<p>
				For questions, tier status review, or support regarding the loyalty program, please contact the InstantCosmetics customer service team.
			</p>
		</div>
	);
}
